(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-video.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-video.js');

'use strict';

const {
  useEffect,
  useMemo,
  useRef,
  useState
} = React;
const {
  useVideoFormat
} = svs.lotto.react.hooks;
const StartVideo = () => {
  const [error, setError] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const {
    format,
    mime,
    codecs
  } = useVideoFormat();
  const videoRef = useRef(null);

  useEffect(() => {
    if (format === null) {
      svs.numbergames.game.animations.lotto.startFadeInText();
    }
  }, [format]);

  useEffect(() => {
    if (!format || svs.lotto.data.cms_videos === undefined) {
      return;
    }
    const videos = svs.lotto.data.cms_videos || [];
    const matchedVideoAndFormat = videos.filter(v => {
      var _v$documentMime;
      return (_v$documentMime = v.documentMime) === null || _v$documentMime === void 0 ? void 0 : _v$documentMime.includes(format);
    });
    if (matchedVideoAndFormat.length > 0) {
      var _matchedVideoAndForma, _svs;
      const docUrl = (_matchedVideoAndForma = matchedVideoAndFormat[0]) === null || _matchedVideoAndForma === void 0 ? void 0 : _matchedVideoAndForma.documentUrl;
      const cdnUrl = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2;
      const url = "https:".concat(cdnUrl).concat(docUrl);
      setVideoUrl(url);
    } else {
      setError(true);
    }
  }, [format]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoUrl) {
      return;
    }
    video.load();
    const play = video.play();
    if (play && typeof play.catch === 'function') {
      play.catch(() => {
        setError(true);
      });
    }
    const isVideoPlaying = () => video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
    const checkTimeout = setTimeout(() => {
      if (!isVideoPlaying()) {
        setError(true);
      }
    }, 1000);
    return () => clearTimeout(checkTimeout);
  }, [videoUrl]);
  const handlePlay = () => {
    svs.numbergames.game.animations.lotto.startFadeInText();
  };

  useEffect(() => {
    if (error) {
      svs.numbergames.game.animations.lotto.startFadeInText();
    }
  }, [error]);
  const source = useMemo(() => {
    if (!format || !videoUrl) {
      return null;
    }
    return React.createElement("source", {
      onError: () => setError(true),
      src: videoUrl,
      type: "".concat(mime, "; codecs=\"").concat(codecs, "\"")
    });
  }, [format, videoUrl, mime, codecs]);
  if (error || !source) {
    return null;
  }
  return React.createElement("div", {
    className: "start-video"
  }, React.createElement("video", {
    autoPlay: true,
    muted: true,
    onError: () => {
      svs.lotto.logger.debug('Startpage: Video playback error');
      setError(true);
    },
    onPlay: handlePlay,
    playsInline: true,
    ref: videoRef
  }, source));
};
setGlobal('svs.lotto.react.components', {
  StartVideo
});

 })(window);